import { $ as e } from "./scene-CqtYl5hY.js";

let t = {
    widthX: 30,
    widthZ: 30,
    columnHeight: 25,
    persidesRotation: 5,
    openClose: 40,
    rollerPosition: 50,
    glassPosition: 100,
    shutterPosition: 50,
    guillotinePosition: 100,
    guillotinePanelCount: 3,
    glassRoofPosition: 100,
    mountingType: "freestanding"
},
n = {
    baseColor: { color: "#293133", name: "RAL 7016" },
    louversColor: { color: "#293133", name: "RAL 7016" },
    rollerAluminium: { color: "#293133", name: "RAL 7016" },
    rollerScreen: { color: "#000000", name: "047" },
    glassAluminium: { color: "#293133", name: "RAL 7016" },
    shutterAluminium: { color: "#293133", name: "RAL 7016" },
    guillotineAluminium: { color: "#293133", name: "RAL 7016" },
    tentoFabric: { color: "#9DA3A6", name: "Light Grey" },
    tentoAluminium: { color: "#293133", name: "RAL 7016" },
    wallColor: "#cccccc"
};

const o = {
    tento_pergko: { widthX: { min: 20, max: 240 }, widthZ: { min: 20, max: 70 } },
    bio_pergko: { widthX: { min: 20, max: 240 }, widthZ: { min: 20, max: 60 } },
    retractable_pergko: { widthX: { min: 20, max: 240 }, widthZ: { min: 20, max: 60 } },
    tilt_retractable_pergko: { widthX: { min: 20, max: 240 }, widthZ: { min: 20, max: 60 } },
    glass_roof_pergko: { widthX: { min: 20, max: 240 }, widthZ: { min: 20, max: 60 } }
};

function l(e, t) {
    const n = new CustomEvent("sliderValuesChanged", { detail: { slider: e, value: t } });
    document.dispatchEvent(n);
}

function updateIntegratedMountingAvailability(pergolaType) {
    const isTentoOrGlass = pergolaType === "tento_pergko" || pergolaType === "glass_roof_pergko";
    const mountIntegratedRadio = document.getElementById("mountIntegrated");
    const mountIntegratedOption = mountIntegratedRadio ? mountIntegratedRadio.closest(".mounting-option") : null;

    if (mountIntegratedRadio) {
        if (isTentoOrGlass) {
            mountIntegratedRadio.disabled = true;
            if (mountIntegratedOption) {
                mountIntegratedOption.classList.add("disabled-option");
                mountIntegratedOption.style.opacity = "0.35";
                mountIntegratedOption.style.pointerEvents = "none";
                mountIntegratedOption.style.cursor = "not-allowed";
            }
            if (mountIntegratedRadio.checked || t.mountingType === "integrated") {
                const wallMountedRadio = document.getElementById("mountWallMounted") || document.getElementById("mountFreestanding");
                if (wallMountedRadio) {
                    wallMountedRadio.checked = true;
                    t.mountingType = wallMountedRadio.value;
                    l("mountingType", wallMountedRadio.value);
                }
            }
        } else {
            mountIntegratedRadio.disabled = false;
            if (mountIntegratedOption) {
                mountIntegratedOption.classList.remove("disabled-option");
                mountIntegratedOption.style.opacity = "";
                mountIntegratedOption.style.pointerEvents = "";
                mountIntegratedOption.style.cursor = "";
            }
        }
    }
}

document.querySelectorAll('input[name="mountingType"]').forEach(e => {
    e.addEventListener("change", e => {
        const val = e.target.value;
        t.mountingType = val;
        l("mountingType", val);
    });
});

document.querySelectorAll('input[name="pergolaType"]').forEach(e => {
    e.addEventListener("change", e => {
        const n = e.target.value,
            a = o[n],
            r = document.getElementById("widthX");
        r && (r.min = a.widthX.min, r.max = a.widthX.max, t.widthX > a.widthX.max && (t.widthX = a.widthX.max, r.value = a.widthX.max, r.nextElementSibling.textContent = a.widthX.max, l("widthX", a.widthX.max)), i(r));
        const s = document.getElementById("widthZ");
        if (s) {
            if (s.min = a.widthZ.min, s.max = a.widthZ.max, t.widthZ > a.widthZ.max) {
                t.widthZ = a.widthZ.max, s.value = a.widthZ.max;
                const e = document.querySelector('output[for="widthZ"]');
                e && (e.textContent = a.widthZ.max);
                const n = document.querySelector('[data-slider="widthZ"]');
                n && (n.value = 10 * a.widthZ.max), l("widthZ", a.widthZ.max);
            }
            i(s);
        }
        updateIntegratedMountingAvailability(n);
        const c = document.getElementById("tentoSideFillingControls"),
            d = document.getElementById("glassSideFillingControls"),
            sh_ctrl = document.getElementById("shutterSideFillingControls"),
            g_ctrl = document.getElementById("guillotineSideFillingControls");
        const isTentoOrGlass = "tento_pergko" === n || "glass_roof_pergko" === n;
        c && (c.style.display = isTentoOrGlass ? "block" : "none", isTentoOrGlass && document.dispatchEvent(new CustomEvent("requestSideElementVisibilityState")));
        d && (d.style.display = isTentoOrGlass ? "block" : "none", isTentoOrGlass && document.dispatchEvent(new CustomEvent("requestSideElementVisibilityState")));
        sh_ctrl && (sh_ctrl.style.display = isTentoOrGlass ? "block" : "none", isTentoOrGlass && document.dispatchEvent(new CustomEvent("requestSideElementVisibilityState")));
        g_ctrl && (g_ctrl.style.display = isTentoOrGlass ? "block" : "none", isTentoOrGlass && document.dispatchEvent(new CustomEvent("requestSideElementVisibilityState")));
    });
});

document.addEventListener("DOMContentLoaded", () => {
    function e(e, t) {
        const n = new CustomEvent("colorChanged", { detail: { colorType: e, colorValue: t } });
        document.dispatchEvent(n);
    }

    const currentType = (document.querySelector('input[name="pergolaType"]:checked') || {}).value;
    if (currentType) updateIntegratedMountingAvailability(currentType);

    const o = document.getElementById("widthX"),
        a = document.getElementById("widthZ"),
        r = document.getElementById("columnHeight"),
        s = document.getElementById("persidesRotation"),
        c = document.getElementById("openClose"),
        d = document.getElementById("rollerPosition"),
        u = document.getElementById("glassPosition"),
        p_shutter = document.getElementById("shutterPosition"),
        p_guillotine = document.getElementById("guillotinePosition"),
        p_glassRoof = document.getElementById("glassRoofPosition");
    let m;

    function g(e) {
        const t = document.querySelector(".control-height p");
        t && (clearTimeout(m), m = setTimeout(() => { t.classList.toggle("warning", e > 25); }, 100));
    }

    o && (o.value = t.widthX, o.addEventListener("input", e => {
        t.widthX = parseFloat(e.target.value);
        const n = document.querySelector('[data-slider="widthX"]');
        n && (n.value = 10 * e.target.value), l("widthX", parseFloat(e.target.value));
    }));

    a && (a.value = t.widthZ, a.addEventListener("input", e => {
        t.widthZ = parseFloat(e.target.value);
        const n = document.querySelector('[data-slider="widthZ"]');
        n && (n.value = 10 * e.target.value), l("widthZ", parseFloat(e.target.value));
    }));

    r && (r.value = t.columnHeight, r.addEventListener("input", e => {
        const n = parseFloat(e.target.value);
        t.columnHeight = n;
        const o = document.querySelector('[data-slider="columnHeight"]');
        o && (o.value = 10 * e.target.value), g(n), l("columnHeight", n);
    }));

    const v = document.querySelector('input[data-slider="columnHeight"]');
    v && v.addEventListener("input", e => { g(parseFloat(e.target.value) / 10); });

    s && (s.value = t.persidesRotation, s.addEventListener("input", e => {
        t.persidesRotation = parseFloat(e.target.value), l("persidesRotation", parseFloat(e.target.value));
    }));

    c && (c.value = t.openClose, c.addEventListener("input", e => {
        t.openClose = parseFloat(e.target.value);
        l("openClose", Math.max(22, Math.min(40, parseFloat(e.target.value))));
    }), i(c));

    d && (d.value = t.rollerPosition, d.addEventListener("input", e => {
        t.rollerPosition = parseFloat(e.target.value), l("rollerPosition", parseFloat(e.target.value));
    }));

    u && (u.value = t.glassPosition, u.addEventListener("input", e => {
        t.glassPosition = parseFloat(e.target.value), l("glassPosition", parseFloat(e.target.value));
    }));

    p_shutter && (p_shutter.value = t.shutterPosition, p_shutter.addEventListener("input", e => {
        t.shutterPosition = parseFloat(e.target.value), l("shutterPosition", parseFloat(e.target.value));
    }));

    p_guillotine && (p_guillotine.value = t.guillotinePosition, p_guillotine.addEventListener("input", e => {
        t.guillotinePosition = parseFloat(e.target.value), l("guillotinePosition", parseFloat(e.target.value));
    }));

    p_glassRoof && (p_glassRoof.value = t.glassRoofPosition, p_glassRoof.addEventListener("input", e => {
        t.glassRoofPosition = parseFloat(e.target.value), l("glassRoofPosition", parseFloat(e.target.value));
    }));

    document.querySelectorAll(".bio-colors .color-buttons .color-btn").forEach(t => {
        t.addEventListener("click", t => {
            const o = t.target.style.backgroundColor,
                l = t.target.getAttribute("data-color").replace("Ral", "RAL "),
                a = t.target.closest(".color-group").getAttribute("data-color-group");
            "base_color" === a ? (n.baseColor = { color: o, name: l }, e("baseColor", o)) : "louvers_color" === a && (n.louversColor = { color: o, name: l }, e("louversColor", o));
        });
    });

    document.querySelectorAll(".tento-colors .color-buttons .color-btn").forEach(t => {
        t.addEventListener("click", t => {
            const o = t.target.style.backgroundColor,
                l = t.target.getAttribute("data-color").replace("Ral", "RAL "),
                a = t.target.closest(".color-group");
            const i = a.getAttribute("data-color-group");
            "base_color" === i ? (n.baseColor = { color: o, name: l }, e("tentoAluminium", o)) : "fabric_color" === i && (n.baseColor = { color: o, name: l }, e("tentoFabric", o));
        });
    });

    document.querySelectorAll(".dimension-input").forEach(e => {
        const n = e.dataset.slider,
            o = document.getElementById(n);
        e.value = 10 * o.value, e.addEventListener("input", e => {
            let a = parseInt(e.target.value) / 10;
            const r = parseInt(o.min),
                s = parseInt(o.max);
            a = Math.min(Math.max(a, r), s), o.value = a, i(o), t[n] = a, l(n, a);
        });
    });

    function closeAllAccordions(exceptElement = null) {
        document.querySelectorAll(".accordion-content").forEach(e => {
            if (e !== exceptElement && e.classList.contains("active")) {
                e.classList.remove("active");
                const t = document.querySelector(`[data-accordion="${e.id}"]`);
                t && t.setAttribute("aria-expanded", "false");
                document.dispatchEvent(new CustomEvent("accordionChanged", { detail: { accordionId: e.id, isOpen: !1 } }));
            }
        });
    }

    if (!window.__UI_TABS_BOUND) {
        window.__UI_TABS_BOUND = true;
        document.addEventListener("click", ev => {
            const btn = ev.target.closest(".tab-btn");
            if (!btn || !btn.dataset.tab) return;
            document.querySelectorAll(".tab-btn").forEach(e => e.classList.remove("active"));
            document.querySelectorAll(".tab-pane").forEach(e => e.classList.remove("active"));
            btn.classList.add("active");
            const pane = document.getElementById(`${btn.dataset.tab}Tab`);
            pane && pane.classList.add("active");
            document.dispatchEvent(new CustomEvent("tabChanged", { detail: { tab: btn.dataset.tab } }));
            if (btn.dataset.tab !== "extras") {
                closeAllAccordions();
            }
        });
    }

    if (!window.__UI_ACCORDION_BOUND) {
        window.__UI_ACCORDION_BOUND = true;
        document.addEventListener("click", ev => {
            const btn = ev.target.closest(".accordion-button");
            if (!btn) return;
            const t = btn.dataset.accordion;
            if (!t) return;
            const n = document.getElementById(t);
            if (!n) return;
            const o = n.classList.contains("active");
            closeAllAccordions(n);
            if (o) {
                n.classList.remove("active");
                btn.setAttribute("aria-expanded", "false");
                document.dispatchEvent(new CustomEvent("accordionChanged", { detail: { accordionId: t, isOpen: !1 } }));
            } else {
                n.classList.add("active");
                btn.setAttribute("aria-expanded", "true");
                document.dispatchEvent(new CustomEvent("accordionChanged", { detail: { accordionId: t, isOpen: !0 } }));
            }
        });
    }

    const p = document.getElementById("wallColorPicker");
    p && (p.addEventListener("input", t => {
        const o = t.target.value;
        n.wallColor = o, t.target.nextElementSibling.textContent = o.toUpperCase(), e("wallColor", o);
    }), p.addEventListener("change", t => {
        const o = t.target.value;
        n.wallColor = o, t.target.nextElementSibling.textContent = o.toUpperCase(), e("wallColor", o);
    }), p.nextElementSibling.textContent = p.value.toUpperCase());
});

// Delegated handler for Side filling cards click-to-expand
if (!window.__UI_SIDE_FILLING_CARDS_BOUND) {
    window.__UI_SIDE_FILLING_CARDS_BOUND = true;
    document.addEventListener("click", ev => {
        const header = ev.target.closest(".side-filling-card-header");
        if (!header) return;
        const card = header.closest(".side-filling-card");
        if (!card) return;
        card.classList.toggle("is-expanded");
    });
}

// Delegated handler for Side filling color buttons
if (!window.__UI_SIDE_FILLING_COLORS_BOUND) {
    window.__UI_SIDE_FILLING_COLORS_BOUND = true;
    document.addEventListener("click", ev => {
        const target = ev.target.closest("#sideFillings button.color-btn, .side-fillings-container button.color-btn, .side-filling-card button.color-btn");
        if (!target) return;
        const color = target.style.backgroundColor;
        const name = (target.getAttribute("data-color") || "").replace("Ral", "RAL ");
        const group = target.closest(".color-group");
        if (!group) return;

        group.querySelectorAll("button.color-btn").forEach(b => b.classList.remove("active"));
        target.classList.add("active");

        const groupType = group.getAttribute("data-color-group");
        const card = target.closest(".side-filling-card, .roller-control, .glass-control, .shutter-control, .guillotine-control");

        const emitColor = (type, val) => {
            document.dispatchEvent(new CustomEvent("colorChanged", { detail: { colorType: type, colorValue: val } }));
        };

        if (groupType === "aluminium_color" || (card && card.classList.contains("roller-control") && groupType !== "screen_color")) {
            n.rollerAluminium = { color, name };
            emitColor("rollerAluminium", color);
        } else if (groupType === "screen_color") {
            const screenName = target.textContent.trim() || name;
            n.rollerScreen = { color, name: screenName };
            emitColor("rollerScreen", color);
        } else if (groupType === "sliding_glass_color" || (card && card.classList.contains("glass-control"))) {
            n.glassAluminium = { color, name };
            emitColor("glassAluminium", color);
        } else if (groupType === "aluminium_shutter_color" || groupType === "shutter_color" || (card && card.classList.contains("shutter-control"))) {
            n.shutterAluminium = { color, name };
            emitColor("shutterAluminium", color);
        } else if (groupType === "guillotine_aluminium_color" || groupType === "guillotine_frame_color" || (card && card.classList.contains("guillotine-control"))) {
            n.guillotineAluminium = { color, name };
            emitColor("guillotineAluminium", color);
        }
    });
}

// Delegated handler for Guillotine panel buttons
if (!window.__UI_GIYOTIN_BTNS_BOUND) {
    window.__UI_GIYOTIN_BTNS_BOUND = true;
    document.addEventListener("click", ev => {
        const target = ev.target.closest(".giyotin-opt-btn");
        if (!target) return;
        const val = parseInt(target.getAttribute("data-val"));
        document.querySelectorAll(".giyotin-opt-btn").forEach(b => b.classList.remove("active"));
        target.classList.add("active");
        t.guillotinePanelCount = val;
        l("guillotinePanelCount", val);
    });
}

document.getElementById("environment-toggle").addEventListener("click", function () {
    document.querySelector(".environment-panel").classList.toggle("active");
});

document.addEventListener("click", function (e) {
    const t = document.querySelector(".environment-panel"),
        n = document.getElementById("environment-toggle");
    t.contains(e.target) || e.target === n || t.classList.remove("active");
});

document.querySelector(".checkbox-label").addEventListener("click", async () => { await e(); });

const a = document.querySelectorAll('input[type="range"]');

function i(e) {
    e.style.setProperty("--range-progress", (e.value - e.min) / (e.max - e.min) * 100 + "%");
}

a.forEach(i);
a.forEach(e => { e.addEventListener("input", e => i(e.target)); });

document.querySelectorAll(".dimension-input").forEach(e => {
    const n = e.dataset.slider,
        o = document.getElementById(n);
    e.value = 10 * o.value, e.addEventListener("input", e => {
        let a = parseInt(e.target.value) / 10;
        const r = parseInt(o.min),
            s = parseInt(o.max);
        a = Math.min(Math.max(a, r), s), o.value = a, i(o), t[n] = a, l();
    });
});

document.getElementById("sidebarToggle").addEventListener("click", () => {
    document.getElementById("sidebarMenu").classList.toggle("collapsed");
});

document.addEventListener("DOMContentLoaded", () => {
    const leftToggle = document.getElementById("leftUpperPartsToggle");
    const rightToggle = document.getElementById("rightUpperPartsToggle");

    leftToggle && leftToggle.addEventListener("change", function () {
        document.dispatchEvent(new CustomEvent("sideElementVisibilityChanged", {
            detail: { element: "leftUpper", visible: this.checked }
        }));
    });

    rightToggle && rightToggle.addEventListener("change", function () {
        document.dispatchEvent(new CustomEvent("sideElementVisibilityChanged", {
            detail: { element: "rightUpper", visible: this.checked }
        }));
    });
});

document.addEventListener("sideElementVisibilityUpdated", e => {
    const d = e.detail;
    const leftToggle = document.getElementById("leftUpperPartsToggle");
    const rightToggle = document.getElementById("rightUpperPartsToggle");
    const leftItem = document.getElementById("leftUpperPartControl");
    const rightItem = document.getElementById("rightUpperPartControl");
    const leftStatus = document.getElementById("leftUpperPartStatus");
    const rightStatus = document.getElementById("rightUpperPartStatus");

    // Left Upper Part status
    const leftHasFilling = !!d.leftHasFilling || (d.leftGlass && d.leftGlass.exists) || (d.leftRoller && d.leftRoller.exists) || (d.leftShutter && d.leftShutter.exists) || (d.leftGuillotine && d.leftGuillotine.exists);
    if (leftToggle && leftItem) {
        leftToggle.disabled = !leftHasFilling;
        leftItem.classList.toggle("disabled-part", !leftHasFilling);
        if (leftHasFilling) {
            if (typeof d.leftUpperVisible === "boolean") leftToggle.checked = d.leftUpperVisible;
            leftStatus && (leftStatus.textContent = leftToggle.checked ? "Active" : "Available (Click toggle to add)");
        } else {
            leftToggle.checked = false;
            leftStatus && (leftStatus.textContent = "Add left side filling first");
        }
    }

    // Right Upper Part status
    const rightHasFilling = !!d.rightHasFilling || (d.rightGlass && d.rightGlass.exists) || (d.rightRoller && d.rightRoller.exists) || (d.rightShutter && d.rightShutter.exists) || (d.rightGuillotine && d.rightGuillotine.exists);
    if (rightToggle && rightItem) {
        rightToggle.disabled = !rightHasFilling;
        rightItem.classList.toggle("disabled-part", !rightHasFilling);
        if (rightHasFilling) {
            if (typeof d.rightUpperVisible === "boolean") rightToggle.checked = d.rightUpperVisible;
            rightStatus && (rightStatus.textContent = rightToggle.checked ? "Active" : "Available (Click toggle to add)");
        } else {
            rightToggle.checked = false;
            rightStatus && (rightStatus.textContent = "Add right side filling first");
        }
    }

    // Side filling cards active state & badges
    const cards = [
        { id: "cardZipScreen", has: !!(d.hasRoller || (d.leftRoller && d.leftRoller.exists) || (d.rightRoller && d.rightRoller.exists)) },
        { id: "cardSlidingGlass", has: !!(d.hasGlass || (d.leftGlass && d.leftGlass.exists) || (d.rightGlass && d.rightGlass.exists)) },
        { id: "cardShutter", has: !!(d.hasShutter || (d.leftShutter && d.leftShutter.exists) || (d.rightShutter && d.rightShutter.exists)) },
        { id: "cardGuillotine", has: !!(d.hasGuillotine || (d.leftGuillotine && d.leftGuillotine.exists) || (d.rightGuillotine && d.rightGuillotine.exists)) }
    ];

    cards.forEach(c => {
        const el = document.getElementById(c.id);
        if (!el) return;
        const badge = el.querySelector(".side-filling-card-badge");
        const had = el.dataset.hasFilling === "true";
        el.dataset.hasFilling = c.has ? "true" : "false";
        el.classList.toggle("disabled-control", !c.has);
        if (c.has) {
            badge && (badge.style.display = "inline-block");
            if (!had) {
                el.classList.add("is-expanded");
            }
        } else {
            badge && (badge.style.display = "none");
            el.classList.remove("is-expanded");
        }
    });
});

export { n as colorValues, t as sliderValues };